<template>
  <el-drawer
    ref="drawerRef"
    :title="title"
    size="55%"
    :with-header="true"
    :visible="drawer"
    v-bind="$attrs"
    :before-close="handleClosed"
    @closed="handleClosed"
  >
    <div style="padding: 5%">
      <el-descriptions class="margin-top" title="DETALLES" :column="1" border>
        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-user"></i>
            CLIENTE
          </template>
          {{ data.ClientName }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-office-building"></i>
            EMPRESA GANADORA
          </template>
          {{ data.CompanyName }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-setting"></i>
            EQUIPOS
          </template>
          {{ data.Equipments }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-date"></i>
            RENOVACIÓN DE CONTRATO
          </template>
          {{ dateFormatter }}
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-money"></i>
            PRECIO
          </template>
          <el-tag>{{ princeFormatter }}</el-tag>
        </el-descriptions-item>

        <el-descriptions-item>
          <template slot="label">
            <i class="el-icon-office-building"></i>
            MÁS DETALLES
          </template>
          {{ data.Companys_Participated }}
        </el-descriptions-item>
      </el-descriptions>
    </div>
  </el-drawer>
</template>

<script>
import { formatDate } from "@/utils";
import { formatMonto } from "@/utils";

export default {
  name: "DealsFormDeclined",
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    },
    company: {
      type: String,
      default: ""
    },
    win: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      dateFormatter: "",
      princeFormatter: "",
      title: "DETALLES DEL CLIENTE"
    };
  },
  methods: {
    formatterData(dateRenovation, priceOffer) {
      this.dateFormatter = formatDate(dateRenovation, "DD/MM/YYYY");
      this.princeFormatter = formatMonto(priceOffer);
    },
    handleClosed() {
      this.$emit("close-drawer");
    }
  }
};
</script>
